import cn from 'classnames';
import { useRegisterDisplayedAttribute } from 'state/tracking';

import { useUnit } from 'state/unit';
import useFormattable, { Formattable } from '../formattable';
import styles from './EpisodeTitle.module.scss';

export interface EpisodeTitleProps
  extends Formattable<string>,
    Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'> {
  className?: string;
}

const EpisodeTitle: React.FC<EpisodeTitleProps> = (props) => {
  const { children, className, ...rest } = props;

  const unit = useUnit();
  const formattedValue = useFormattable(unit?.episode?.episodeName, props);

  useRegisterDisplayedAttribute(unit?.resultId, 'episodeName');

  return !unit ? null : (
    <span className={cn(styles.root, className)} {...rest}>
      {formattedValue}
    </span>
  );
};

export default EpisodeTitle;
